import { css } from 'styled-components';

import {
    Sizes,
    Colours,
} from '@ratehub/base-ui';


const CalculatorGridStyles = css`
    > .row {
        display: grid;
        align-items: center;

        gap: ${Sizes.SPACING.ONE};
        margin: ${Sizes.SPACING.ONE} 0;
        padding: 0 ${Sizes.SPACING.ONE};

        ${({ $columnCount }) => $columnCount && `
            grid-template-columns: repeat(${$columnCount + 1}, 1fr);
        `}

        &:last-child {
            margin-bottom: 0;
        }

        &--blue-light {
            padding: ${Sizes.SPACING.THREE_QUARTERS} ${Sizes.SPACING.ONE};
            background-color: ${Colours.BLUEBERRY_LIGHTEST};
        }

        .blue-dark {
            color: ${Colours.BLUEBERRY_DARK};
            margin-bottom: 0;
        }

        .wideCol {
            grid-column: 1/3; // Spans two columns on small displays
        }

        .col-0 {
            grid-column: 1/2;

            display: flex;
            align-items: center;
        }
        .col-1 { grid-column: 2/3; }
        .col-2 { grid-column: 3/4; }
        .col-3 { grid-column: 4/5; }
        .col-4 { grid-column: 5/6; }

        .hidden {
            display: none;
        }

        .operator {
            margin-right: ${Sizes.SPACING.ONE};
            margin-bottom: 0;
        }

        .tooltip {
            margin-left: auto;
        }

        .downPaymentPercent {
            margin-bottom: ${Sizes.SPACING.HALF};
        }
    }

    .rate-selector {
        position: relative;
    }
`;

export default CalculatorGridStyles;
